<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      refCount: 0,
      isLoading: false
    }
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = (this.refCount > 0);
      }
    },
  },
  created() {
    axios.interceptors.request.use((config) => {
        this.setLoading(true);
        return config;
    }, (error) => {
        this.setLoading(false);
        return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
        this.setLoading(false);
        return response;
    }, (error) => {
        this.setLoading(false);
        return Promise.reject(error);
    });
  },
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "~uppy/dist/uppy.css";
</style>

